import { Injectable } from '@angular/core';
import { HttpClient, HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { environment } from "../../../environments/environment";
import { ItemCart } from 'src/app/model/itemCart';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CartService {

  panierCount=0;
  favorisCount=0;
  urlBase = environment.urlApi;
  constructor(private http: HttpClient) {
    if (JSON.parse(localStorage.getItem('card'))!=null && JSON.parse(localStorage.getItem('card'))!=undefined ) {
      this.panierCount = JSON.parse(localStorage.getItem('card')).length;
    }else{
      this.panierCount = 0;
    }

    if (JSON.parse(localStorage.getItem('favoris'))!=null && JSON.parse(localStorage.getItem('favoris'))!=undefined ) {
      this.favorisCount = JSON.parse(localStorage.getItem('favoris')).length;
    }else{
      this.favorisCount = 0;
    }

   }


  getCart()
  {
    return this.http.get(this.urlBase+"/cart/all?token="+localStorage.getItem('token'));
  }

  addTocart(item)
  {
    return this.http.post(this.urlBase+"/cart/add?token="+localStorage.getItem('token'),item);
  }

  updateItemCart(item)
  {
    return this.http.put(this.urlBase+"/cart/update?token="+localStorage.getItem('token'),item);
  }

  removeFromCart(itemId)
  {
    return this.http.delete(this.urlBase+"/cart/deleteItem?item="+itemId+"&token="+localStorage.getItem('token'));
  }

  confirmeCart(data=null)
  { 
    return this.http.post(this.urlBase+"/confirmOrder?token="+localStorage.getItem('token'),data);
  }



}
